import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { useState } from "react";
import { QuestionCategoryFormValues } from "src/models/QuestionCategory.model";
import { useAddQuestionCategoryMutation } from "src/services/QuestionCategoryServices";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import JobForm from "../Layout/QuestionCategoryForm";
type Props = {
  onClose: () => void;
};

const AddQuestionCategoryFormWrapper = ({ onClose }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addJob] = useAddQuestionCategoryMutation();

  // Form Initial Values
  const initialValues: QuestionCategoryFormValues = {
    category: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    category: string().required("Please enter category"),

  });

  // Handle Submit
  const handleSubmit = (
    values: QuestionCategoryFormValues,
    { setSubmitting, resetForm }: FormikHelpers<QuestionCategoryFormValues>
  ) => {
    const formatedValue = {
      categoryName: values.category,

    };

    addJob(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          if (!saveNextChecked) {
            resetForm();
            onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='sm' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            <JobForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddQuestionCategoryFormWrapper;
